import { Skill } from '@umanforge/common';

import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';


interface ILUOSkillProps {
  skill: Skill;
  onChange: ( skill: { id: string, value: number } ) => void;
}

export function ILUOSkill( { skill, onChange }: ILUOSkillProps ) {
  const { t } = useTranslation();

  const [ value, setValue ] = useState<number>( skill.value ?? 1 );

  const iluoSquareByValue = (): ReactElement<unknown, string> | null => {
    switch ( value ) {
    case 1: return ( <path id={String( value )} d={'M 4 16 4 4 4 4 z'} stroke='#FF5555'></path> );
    case 2: return ( <path id={String( value )} d={'M 4 4  4 16  16 16 4 16 z'} stroke='#FF9944'></path> );
    case 3: return ( <path id={String( value )} d={'M 16 4  16 16  4 16  4 4  4 16 16 16 z'} stroke='#33BBDD'></path> );
    case 4: return ( <path id={String( value )} d={'M 16 4 16 16 4 16 4 4 16 4 16 4 z'} stroke='#44BB44'></path> );
    default: return null;
    }
  };

  return (
    <>
      <div
        className='relative h-fit w-fit mr-2'
        id={ 'iluo-' + skill.id }
      >
        <input
          type='button'
          className='absolute z-20 w-full h-full cursor-pointer'
          onClick={ () => {
            const newValue = ( value ?? 1 ) % 4 + 1;
            setValue( newValue );
            onChange( { id: skill.id, value: newValue } );
          } }
        />
        <div className='flex items-center w-fit bg-off-white relative justify-center rounded'>
          <svg viewBox="3 3 14 14" className="w-8" strokeWidth={2} strokeLinecap="round" fill="none" strokeLinejoin="round">
            <g> { iluoSquareByValue() } </g>
          </svg>
          <p className="absolute select-none">{ value }</p>
        </div>
      </div>
      <Tooltip
        anchorSelect={ '#iluo-' + skill.id }
        className='z-[1000] max-w-[600px] text-wrap'
        place="top"
        positionStrategy='fixed'
      >
        <span>
          <span className='text-[14px] font-semibold underline underline-offset-2'>
            { t( 'ILUO level' ) }
          </span>
          <ul className='pl-6 pt-1 list-decimal'>
            <li>
              { t( 'The employee applies the operating procedure and works safely' ) }
            </li>
            <li>
              { t( 'The employee applies the operating procedure and achieves the expected quality.' ) }
            </li>
            <li>
              { t( 'The employee knows the operating procedure and produces the expected quality and quantity.' ) }
            </li>
            <li>
              { t( 'The employee is an expert (the square is whole). She knows the procedure, makes the expected quality and quantity and is able to train others.' ) }
            </li>
          </ul>
        </span>
      </Tooltip>
    </>
  );
}